// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuillDateRangePicker-base__ABYTg{display:flex;flex-direction:column;gap:var(--size-1);min-width:var(--size-40)}.QuillDateRangePicker-inputGroup__fJzP8{display:flex;align-items:stretch}.QuillDateRangePicker-dateButton__ieVUM{border-top-right-radius:0;border-bottom-right-radius:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "QuillDateRangePicker-base__ABYTg",
	"inputGroup": "QuillDateRangePicker-inputGroup__fJzP8",
	"dateButton": "QuillDateRangePicker-dateButton__ieVUM"
};
export default ___CSS_LOADER_EXPORT___;
